import {
  Box,
  Button,
  Spacer,
  Text,
  IconButton,
  useDisclosure,
  DrawerOverlay,
  Skeleton,
  Drawer,
  DrawerContent,
  Heading,
  Image,
  Grid,
  GridItem,
  Center,
  Input,
  InputRightElement,
  InputGroup,
  Flex,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { HamburgerIcon } from "@chakra-ui/icons";
import React from "react";
import { home } from "../../images/svg";
import { Link, useNavigate } from "react-router-dom";
import { listingRecommended, searchLocation } from "../../utils/fetch";
import { GiReceiveMoney } from "react-icons/gi";
import { useEffect, useState, useRef } from "react";
import { HiSearch } from "react-icons/hi";
import { BiSearchAlt } from "react-icons/bi";
import { CgFileDocument } from "react-icons/cg";
import { GiHouseKeys } from "react-icons/gi";
import { useQuery } from "react-query";
const NavBar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const btnRef = React.useRef();
  const admin = JSON.parse(localStorage.getItem("isAdmin"));

  const token =
    localStorage.getItem("token") && JSON.parse(localStorage.getItem("token"));
  const navigate = useNavigate();

  const [showInfo, setShowInfo] = useState(false);
  const [location, setLocation] = useState("");
  const { isLoading, data } = useQuery(["searchLocation", location], () =>
    searchLocation(location)
  );
  const { data: listingData, isLoading: loaders } = useQuery(
    "get-listingRecommended",
    listingRecommended
  );

  const InfoData = [
    {
      img: <BiSearchAlt size="25px" />,
      tittle: "Property Search",
      content:
        "Embark on property search with confidence by exploring diverse neighborhoods and prioritizing your must-have features.",
    },
    {
      img: <GiReceiveMoney size="25px" />,
      tittle: "Contact Us",
      content:
        "Reach out to any of our contact personnel to get a precise house value assessment.",
    },
    {
      img: <CgFileDocument size="25px" />,
      tittle: "Documentation",
      content:
        "Our documentation process is efficient and streamlined to ensure a swift transaction",
    },
    {
      img: <GiHouseKeys size="25px" />,
      tittle: "Acquire",
      content: "Deal finalized",
    },
  ];
  const uniqueArray = [
    ...new Set(data?.data?.data?.map((item) => item.toLowerCase())),
  ];
  const shuffledArray = uniqueArray.sort(() => Math.random() - 0.5);
  const handlelLocation = (e) => {
    e.preventDefault();
    navigate(`/search?location=${location}`);
  };
  const refOne = useRef(null);
  useEffect(() => {
    document.addEventListener("click", hideOnClickOutside, true);
  }, []);
  const hideOnClickOutside = (e) => {
    if (refOne.current && !refOne.current.contains(e.target)) {
      setShowInfo(false);
    }
  };

  const logoutHandler = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("email");
    localStorage.removeItem("isAdmin");
    localStorage.removeItem("firstname");
    localStorage.removeItem("lastname");
    localStorage.removeItem("user_id");
    localStorage.removeItem("phone");
    localStorage.removeItem("listingRedirect");
    window.location.href = "/";
  };

  const menuData = [
    {
      name: "Buy",
      link: "/search?rent=&lease=&buy=true&shortlet=",
    },
    {
      name: "Rent",
      link: "/search?rent=true&lease=&buy=&shortlet=",
    },
    // {
    //   name: "Shortlet",
    //   link: "/search?rent=&lease=&buy=&shortlet=true",
    // },
    {
      name: "Lease",
      link: "/search?rent=&lease=true&buy=&shortlet=",
    },

    { name: "List your property", link: "/listing-info" },
  ];
  const accountMenuData = [
    { name: "About us", link: "/about-us" },
    {
      name: token ? "My Account" : "Register",
      link: token ? `${admin ? "/admin/home" : "/admin/listing"}` : "/signup",
    },
    {
      name: token ? "" : "Login",
      link: token ? "" : "/login",
    },
  ];
  return (
    <Box
      bg="primary"
      position="absolute"
      color="white"
      width="100%"
      pb="50px"
      boxShadow="rgba(0, 0, 0, 0.24) 0px 3px 8px"
    >
      <Flex
        bg="primary"
        display={["none", "none", "flex", "flex"]}
        justifyContent="flex-end"
        borderBottom="1px solid white"
      >
        <Box w="400px" my="5px">
          <InputGroup size="md">
            <Input
              py="15px"
              pr="4.5rem"
              color="black"
              bg="white"
              value={location}
              borderRadius="50px"
              onChange={(e) => setLocation(e.target.value)}
              onClick={() => setShowInfo(true)}
              placeholder="Enter Address, City or Neighbourhood"
            />
            <InputRightElement width="4.5rem">
              <Button
                variant="primary"
                m="10px"
                mr="-20px"
                borderRadius="70px"
                p="5px"
                size="sm"
                onClick={handlelLocation}
              >
                <HiSearch size="20px" />
              </Button>
            </InputRightElement>
          </InputGroup>
          {showInfo && (
            <Box
              ref={refOne}
              mt="5px"
              zIndex="1000"
              w="auto"
              bg="white"
              p="10px"
              height="auto"
              maxH="300px"
              minW="400px"
              position="absolute"
              boxShadow="rgba(0, 0, 0, 0.16) 0px 1px 4px"
              overflowY="scroll"
              borderRadius="20px"
              css={{
                "&::-webkit-scrollbar": {
                  width: "6px",
                },
                "&::-webkit-scrollbar-track": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "#4B978B",
                  borderRadius: "24px",
                },
              }}
            >
              {isLoading &&
                [1, 6, 7, 7, 8, 8, 7, 7]?.map((data) => (
                  <Skeleton h="10px" w="90%" mt="10px" mb="10px" />
                ))}
              {!isLoading && data?.data?.data?.length < 1 && (
                <Heading size="sm">No Property Found in this Location</Heading>
              )}
              {shuffledArray?.map((item) => (
                <>
                  <Text
                    fontSize="15px"
                    mb="4px"
                    mt="4px"
                    cursor="pointer"
                    onClick={() => {
                      setLocation(item);
                      setShowInfo(false);
                    }}
                    color="black"
                    _hover={{
                      color: "#4B978B",
                    }}
                  >
                    {item}
                  </Text>
                  <hr style={{ border: "1px solid  #E2E8F0" }}></hr>
                </>
              ))}
            </Box>
          )}
        </Box>
        {accountMenuData.map((data, index) => (
          <Button
            mt="5px"
            key={data?.name}
            variant="transButton2"
            onClick={() => {
              navigate(data?.link);
            }}
          >
            {data?.name}
          </Button>
        ))}
        {token && (
          <Button mt="5px" variant="transButton2" onClick={logoutHandler}>
            Logout
          </Button>
        )}
      </Flex>
      <Box pl="20px" pr="20px" pt={2} h="28px">
        <Flex>
          <Link to="/">
            <Heading size="md" mt="6px">
              {home}
            </Heading>
          </Link>

          <Spacer />
          <Box display={["none", "none", "none", "flex", "flex", "flex"]}>
            {menuData.map((data) => (
              <Button
                key={data?.name}
                mt="10px"
                mr="30px"
                onClick={() => {
                  window.location.href = data?.link;
                }}
                variant="transButton2"
              >
                {data?.name}
              </Button>
            ))}
          </Box>
          <Box
            display={["flex", "flex", "flex", "none", "none", "none"]}
            mt="10px"
          >
            <Button
              as={IconButton}
              onClick={onOpen}
              aria-label="Options"
              icon={<HamburgerIcon />}
              bg="white"
            />
            <Drawer
              isOpen={isOpen}
              placement="right"
              onClose={onClose}
              finalFocusRef={btnRef}
              size="xs"
            >
              <DrawerOverlay />
              <DrawerContent textAlign="left">
                <DrawerCloseButton />
                <Box mt="70px" p="20px">
                  {menuData?.map((data) => (
                    <Box key={data}>
                      <Button
                        variant="transButton3"
                        onClick={() => {
                          navigate(data?.link);
                          onClose(true);
                        }}
                      >
                        {data?.name}
                      </Button>
                      <br></br>
                    </Box>
                  ))}
                  <hr style={{ border: "1px solid  #E2E8F0" }}></hr>
                  {accountMenuData?.map((data) => (
                    <Box key={data?.name}>
                      <Button
                        variant="transButton3"
                        onClick={() => {
                          window.location.href = `${data?.link}`;
                        }}
                      >
                        {data?.name}
                      </Button>
                      <br></br>
                    </Box>
                  ))}
                  {token ? (
                    <>
                      <Button
                        onClick={logoutHandler}
                        color="primary"
                        variant="transButton3"
                        mt={token ? "-70px" : ""}
                      >
                        Sign Out
                      </Button>
                      <br></br>
                    </>
                  ) : (
                    <> </>
                  )}
                </Box>
              </DrawerContent>
            </Drawer>
          </Box>
        </Flex>
      </Box>
    </Box>
  );
};

export default NavBar;
